import { useLang } from "@/contexts/LanguageContext";

const PoliticaPrivacidad = () => {
  const { t } = useLang();

  return (
    <div data-testid="page-politica-privacidad">
      <section className="px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium">
            {t.footer.legal}
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] text-ink">
            {t.footer.privacy}
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
        <article className="max-w-4xl mx-auto space-y-12 text-ink-muted font-light text-base md:text-lg leading-relaxed">
          <p>
            <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> (B-01998939),
            con dirección en Camí de Muntanya nº 7 — Polígono de Marratxí, 07141 Mallorca, Illes Balears, es titular
            de la website <a href="https://www.lacriollita.com" className="text-wine hover:text-wine-hover underline-offset-4 hover:underline">www.lacriollita.com</a>, y como tal le informa que para hacer uso de los
            servicios que le ofrece es necesario que nos suministre determinados datos de carácter personal.{" "}
            <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> actuará de conformidad con lo
            establecido en la legislación vigente y, en concreto, de conformidad con lo establecido en el
            Reglamento Europeo de Protección de Datos (RGPD), en la Ley Orgánica de Protección de Datos (LOPD) y
            en la Ley de Servicios de la Sociedad de la Información (LSSI), en lo referente al mantenimiento de la
            confidencialidad y tratamiento de datos personales facilitados voluntariamente por los usuarios de
            esta página Web.
          </p>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Consentimiento y autorización al tratamiento de sus datos personales
            </h2>
            <div className="space-y-5">
              <p>
                Le informamos que los datos personales obtenidos a través de los formularios de recogida de datos
                de <strong className="text-ink font-medium">www.lacriollita.com</strong> serán tratados por{" "}
                <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> con la finalidad de
                gestionar su solicitud y el mantenimiento de las relaciones profesionales y comerciales con
                usted, así como para mantener un vínculo informativo y promocional con Ud., de forma que pueda
                recibir, por diferentes medios (telefónico, sms, mails) comunicaciones sobre ofertas, productos y
                servicios que puedan resultar de su interés en caso de que Usted nos haya dado su consentimiento
                previamente.
              </p>
              <p>
                Sus datos personales no serán cedidos a terceros, salvo que sean requeridos por ley o por las
                autoridades competentes.
              </p>
              <p>
                La base que legitima el tratamiento de sus datos es su consentimiento dado al cumplimentar
                voluntariamente el formulario correspondiente con sus datos personales y aceptar la presente
                Política de Privacidad y/o al marcar la casilla de aceptación de recibir comunicaciones
                comerciales. Sus datos serán conservados hasta que Usted revoque su consentimiento o se oponga al
                tratamiento de sus datos con esta finalidad.
              </p>
              <p>
                <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> le informa de que en
                ningún caso está obligado a facilitarnos sus datos personales, y que éstos son los adecuados,
                pertinentes y estrictamente necesarios para cumplir con la finalidad por la que se recogen, no
                obstante, estos son imprescindibles para dar respuesta a su solicitud o para proporcionarle los
                servicios ofertados.
              </p>
              <p>
                Si usted se ha puesto en contacto con nosotros vía correo electrónico, le informamos que los
                datos personales que usted nos haya facilitado serán tratados por{" "}
                <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> con la finalidad de
                gestionar y mantener las relaciones profesionales que nos unen con usted. Para la realización de
                esta gestión es posible que sus datos sean comunicados a las entidades y administraciones
                públicas necesarias para la realización de dicha gestión. Este tratamiento de datos es necesario
                para mantener dicha relación profesional. Igualmente, le informamos que sus datos serán
                conservados mientras se mantengan estas relaciones y los plazos marcados por la legislación
                fiscal o durante los plazos establecidos para atender posibles reclamaciones.
              </p>
              <p>
                Si Usted nos ha enviado su currículum a las direcciones postales o electrónicas de{" "}
                <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> o nos lo ha facilitado
                a través de bolsas de empleo de terceros (LinkedIn, Infojobs, Universidades o Escuelas), le
                informamos que sus datos serán tratados por{" "}
                <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong> para la gestión de sus
                procesos de selección de personal de puestos vacantes en la empresa. Sus datos no serán cedidos a
                terceros. Este tratamiento de datos es necesario para atender su solicitud de empleo y está
                basado en el consentimiento que Usted nos da al enviarnos su currículum. Sus datos serán
                conservados únicamente si hay un proceso de selección abierto y, en este caso, hasta la
                finalización del proceso.
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Derechos de protección de datos del interesado
            </h2>
            <p>
              A los efectos de lo dispuesto en la normativa vigente, Ud. puede ejercer sus derechos de acceso,
              rectificación, supresión, oposición, a no ser objeto de decisiones individuales automatizadas,
              portabilidad y limitación del tratamiento de sus datos dirigiéndose al Responsable de Protección
              de Datos de <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong>, reseñado
              anteriormente, o a la dirección de correo electrónico{" "}
              <a
                href="mailto:contacto@lacriollita.eu"
                className="text-wine hover:text-wine-hover underline-offset-4 hover:underline"
              >
                contacto@lacriollita.eu
              </a>{" "}
              acompañando copia de su DNI acreditando debidamente su identidad. Ud. tiene derecho a presentar una
              reclamación ante la Agencia Española de Protección de Datos (AEPD) si considera infringidos sus
              derechos.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Actualización y cancelación de sus datos
            </h2>
            <div className="space-y-5">
              <p>
                Es importante que para que podamos mantener sus datos personales actualizados, nos informe
                siempre que haya habido alguna modificación en ellos; en caso contrario, no respondemos de la
                veracidad de los mismos. Asimismo, nos certifica que todos los datos que Ud. nos facilita son
                ciertos, vigentes y pertinentes para la finalidad por la que se los solicitamos, y que los
                facilita por sí mismo.
              </p>
              <p>
                Sus datos serán conservados hasta que Usted revoque su consentimiento o se oponga al tratamiento
                de sus datos con esta finalidad, sin que ello condicione otras relaciones que mantenga con la
                entidad.
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Garantía de confidencialidad y seguridad de los datos
            </h2>
            <p>
              <strong className="text-ink font-medium">BAIRES FOOD SPAIN S.L.</strong>, en respuesta a la
              confianza depositada en nosotros y teniendo en cuenta la importancia en materia de protección y
              confidencialidad que requieren sus datos personales, le informa que ha adoptado las medidas
              técnicas y organizativas necesarias para garantizar la confidencialidad, disponibilidad, integridad
              y resiliencia de sus sistemas y servicios de tratamiento. No obstante, el usuario debe ser
              consciente de que las medidas de seguridad en Internet no son inexpugnables.
            </p>
          </div>

          <div className="pt-8 border-t border-bone">
            <p className="text-sm italic">
              La presente política de privacidad ha sido actualizada el 7 de diciembre de 2018.{" "}
              <strong className="text-ink not-italic font-medium">BAIRES FOOD SPAIN S.L.</strong> se reserva el
              derecho de modificar su política de protección de datos en el supuesto de que exista un cambio de
              la legislación vigente, doctrina jurisprudencial o por criterios propios empresariales. Si se
              introdujese algún cambio en esta política, el nuevo texto se publicará en esta misma dirección.
            </p>
          </div>
        </article>
      </section>
    </div>
  );
};

export default PoliticaPrivacidad;
